import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { createRouter } from './router'
import { createStore } from './store'
// import { BootstrapVue } from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import './assets/sass/global.scss'

// Removed JWT token configuration as the API server doesn't require authentication
// axios.defaults.headers.common['Authorization'] = 'Bearer ' +process.env.VUE_APP_API_TOKEN;

// Add axios interceptor to handle API errors gracefully
axios.interceptors.response.use(
    response => response,
    error => {
        // Only log non-404 errors at global level to reduce noise
        if (error.response && error.response.status !== 404) {
            const { status, statusText } = error.response;
            console.error(`API Error: ${status} ${statusText} - ${error.config?.url}`);

            // Handle specific error types
            if (status === 403) {
                console.error('Authentication failed - token may be expired');
            } else if (status >= 500) {
                console.error('Server error');
            }
        }

        return Promise.reject(error);
    }
);

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
// Vue.use(BootstrapVue)
Vue.use(VueMeta, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid',
    refreshOnceOnNavigation: true
})

// Analytics is now handled entirely through Google Tag Manager (GTM)
// GTM will manage Google Analytics and respect CookieScript consent
// No additional JavaScript code needed here


Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

export async function createApp ({
          beforeApp = () => {},
          afterApp = () => {}
        } = {}) {
          const router = createRouter()
          const store = createStore()

          await beforeApp({
            router,
            store,

          })

          const app = new Vue({
  router,
  store,
  render: h => h(App)
})

          const result = {
            app,
            router,
            store,

          }

          await afterApp(result)

          return result
        }
